import { Button } from 'blaze-ui/Button'
import { MobileWizard } from 'components/Wizards/MobileWizards/Layout'
import { ArrowRight } from 'blaze-ui/icons'
import { multiStep } from 'components/Wizards/MobileWizards/MultiStepMobileWizard/multiStep'
import { Field as BaseField } from 'components/Wizards/MobileWizards/Field/Field'
import { BrandKitField } from '../../Fields/BrandKitField'
import { useState, useRef, useEffect, useCallback } from 'react'
import { useAutocomplete } from 'components/Wizards/DesktopWizards/useAutocomplete'
import { useFormikContext, FormikValues } from 'formik'
import { useWizardSchema } from 'components/Wizards/Wizard/WizardContext'
import { MultiStepSchema, WizardType } from 'components/Wizards/schemas/Types'
import { TextFieldLoadingState } from 'components/Wizards/TextFieldLoadingState/TextFieldLoadingState'
import { PollFieldsetCompletion } from 'components/PollFieldsetCompletion/PollFieldsetCompletion'
import { TopicField } from '../../Fields/TopicField'

export const TopicSelector = multiStep(({ schema, submit, getSchemaField }) => {
  const { meta } = schema.describe()
  const { values, setFieldValue, setStatus, initialStatus } = useFormikContext<FormikValues>()
  const topicField = getSchemaField('topic')
  const [isLoading, setIsLoading] = useState(false)
  const userEditedTopic = useRef(false)
  const hasInitialized = useRef(false)

  const wizardSchema = useWizardSchema() as MultiStepSchema<WizardType>

  const { handleGenerate, handleComplete, data } = useAutocomplete({
    schema: wizardSchema,
    values,
    setFieldValue,
    setStatus,
    initialStatus,
    onLoadingChange: setIsLoading,
  })

  useEffect(() => {
    if (!hasInitialized.current) {
      hasInitialized.current = true

      if (topicField && !values['topic']) {
        handleGenerate({ fields: ['topic'] })
      }
    }
  }, [topicField, values, handleGenerate])

  const handleTopicKeyDown = useCallback(() => {
    userEditedTopic.current = true
  }, [])

  const handleBrandKitChange = (brandKitId: number) => {
    if (userEditedTopic.current) return

    handleGenerate({ fields: ['topic'], newCompletedFields: { brand_kit_id: brandKitId } })
  }

  return (
    <>
      <PollFieldsetCompletion fieldsetCompletionId={data?.fieldset_completion?.id} onComplete={handleComplete} />

      <MobileWizard.Content>
        <MobileWizard.Section>
          <MobileWizard.Title>{meta.title}</MobileWizard.Title>
        </MobileWizard.Section>

        {topicField && (
          <>
            <BaseField name="topic" label={topicField.describe().meta.label}>
              {isLoading ? (
                <TextFieldLoadingState lines={4} />
              ) : (
                <TopicField schema={topicField} onKeyDown={handleTopicKeyDown} />
              )}
            </BaseField>
          </>
        )}

        <BaseField name="brand_kit_id" label="Pick a Brand Kit">
          <BrandKitField onBrandKitChange={handleBrandKitChange} />
        </BaseField>
      </MobileWizard.Content>

      <MobileWizard.ButtonFooter>
        <Button size="lg" variant="primary" endIcon={ArrowRight} fullWidth onPress={submit} isDisabled={isLoading}>
          {meta.submitLabel}
        </Button>
      </MobileWizard.ButtonFooter>
    </>
  )
})
